import { AeropuertoRaw, Aeropuerto } from "./types/aeropuerto";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchAeropuerto(lang: Locale): Promise<Aeropuerto> {
  const res = await fetchWithRetry<{ data: AeropuertoRaw[] }>(
    `/aeropuertos?lang=${cmsLang(lang)}`
  );
  const item = res.data[0];

  return {
    id: item.id,
    nombre: item.nombre,
    descripcion: item.descripcion,
    banner1: item.banner1,
    banner2: item.banner2,
    banner3: item.banner3,
    banner1Empresa: item.banner1_empresa,
    banner2Empresa: item.banner2_empresa,
    banner3Empresa: item.banner3_empresa,
  };
}
